import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useRequestResolvedBranchQuery } from '@/features/branches/services/Branches.service';
import { useRequestSupportMethodsQuery } from '@/core/services/SettingsManagement.service';
import { Loader } from '@wunder/ui-components';

const RedirectToBusinessAccount = () => {
  const { pathname } = useLocation();
  const { isLoading: isLoadingBranches } = useRequestResolvedBranchQuery();
  const { isLoading: isLoadingSupportMethods } = useRequestSupportMethodsQuery();

  if (isLoadingBranches || isLoadingSupportMethods) {
    return <Loader cover fixed />;
  }

  if (pathname === '/') {
    return <Navigate to="/business-account" />;
  }

  return <Outlet />;
};

export default RedirectToBusinessAccount;
